// Action Constants
import { BUDGET_STORE_CONSTANTS, REPORT_LANDING_STORE_CONSTANTS } from '../actionConstants';

// App Constants (API Paths etc.)
import { PATHS } from 'AppConstants';

// Saga Utility Functions
import { actionCreator, successFor, failedFor } from '../sagaUtil';


// Will remove this after testing
    // export const getDetails = actionCreator(REPORT_DETAILS_STORE_CONSTANTS.GET_DETAILS_LISTING);
    // export const setDetails = actionCreator(REPORT_DETAILS_STORE_CONSTANTS.SET_DETAILS_LISTING);
    // export const setApiLoading = actionCreator(REPORT_DETAILS_STORE_CONSTANTS.DETAILS_API_LOADING);
    // export const setApiError = actionCreator(failedFor(REPORT_DETAILS_STORE_CONSTANTS.DETAILS_API));
    // export const setApiSuccess = actionCreator(successFor(REPORT_DETAILS_STORE_CONSTANTS.DETAILS_API));
    // export const resetApiState = actionCreator(REPORT_DETAILS_STORE_CONSTANTS.RESET_REPORT_DETAIL_API);
    // export const setReportType = actionCreator(REPORT_DETAILS_STORE_CONSTANTS.SET_REPORT_TYPE);
    // export const setSelected = actionCreator(REPORT_DETAILS_STORE_CONSTANTS.UPDATE_DETAILS_SELECTED);
    // export const setFilterQuery = actionCreator(REPORT_DETAILS_STORE_CONSTANTS.DETAIL_FILTER_QUERY);
    // export const updateQueryPage = actionCreator(REPORT_DETAILS_STORE_CONSTANTS.DETAIL_UPDATE_PAGE);
    // export const updateSortQuery = actionCreator(REPORT_DETAILS_STORE_CONSTANTS.DETAIL_UPDATE_SORT);
    // export const clearFilterUpdate = actionCreator(REPORT_DETAILS_STORE_CONSTANTS.DETAIL_FILTER_CLEAR);
    // export const getFilterCount = actionCreator(REPORT_DETAILS_STORE_CONSTANTS.RPRT_DETAILS_FILTER_COUNT);
    // export const getFilterCountSuccess = actionCreator(successFor(REPORT_DETAILS_STORE_CONSTANTS.RPRT_DETAILS_FILTER_COUNT));
    // export const setReportSearchStr = actionCreator(REPORT_DETAILS_STORE_CONSTANTS.REPORT_DETAILS_SEARCH);
    // export const updateSearch = actionCreator(REPORT_DETAILS_STORE_CONSTANTS.UPDATE_DETAILS_SEARCH);
    // export const updateReportLevel = actionCreator(REPORT_DETAILS_STORE_CONSTANTS.UPDATE_REPORTS_LEVEL);
    // export const getAbValuesDetails = actionCreator(REPORT_DETAILS_STORE_CONSTANTS.GET_AB_VALS_DETAILS);

    // export const getAbValsDetailsSuccess = actionCreator(successFor(REPORT_DETAILS_STORE_CONSTANTS.GET_AB_VALS_DETAILS));
    // export const setReportLevel = actionCreator(REPORT_DETAILS_STORE_CONSTANTS.SET_REPORT_LEVEL);
    // report/Budget Actions
// Will remove this after testing




/* ----------------- Budget List Actions ----------------- */
export const getBudgetList = actionCreator(PATHS.GET_BUDGET_LIST);
export const setDetails = actionCreator(BUDGET_STORE_CONSTANTS.SET_BUDGET_LISTING);

/* API Status Actions */
export const setApiLoading = actionCreator(BUDGET_STORE_CONSTANTS.LIST_API_LOADING);
// export const setApiError = actionCreator(failedFor(BUDGET_STORE_CONSTANTS.LIST_API_ERROR));
// export const setApiSuccess = actionCreator(successFor(BUDGET_STORE_CONSTANTS.LIST_API_SUCCESS));

/* ----------------- Budget Export Actions ----------------- */
export const getBudgetExport = actionCreator(PATHS.GET_BUDGET_EXPORT);

/* ----------------- Selection & Filter Actions ----------------- */
export const setSelected = actionCreator(BUDGET_STORE_CONSTANTS.UPDATE_BUDGET_SELECTED);
export const setFilterQuery = actionCreator(BUDGET_STORE_CONSTANTS.BUDGET_FILTER_QUERY);
export const clearFilterUpdate = actionCreator(BUDGET_STORE_CONSTANTS.BUDGET_FILTER_CLEAR);
export const setModal = actionCreator(BUDGET_STORE_CONSTANTS.SET_MODAL);





